<template>
<div></div>
</template>

<script>
export default {
  name: 'Show'
}
</script>

<style scoped>

</style>
